import type { User } from "@/types/auth";

export function isElevatedRole(role: User["role"] | null | undefined): boolean {
  return role === "staff";
}
